// extracted by mini-css-extract-plugin
export default {"container":"Structure_container__SIrh+","edit":"Structure_edit__pPWAH","icon":"Structure_icon__31IPL","content":"Structure_content__vZVQK","rotate":"Structure_rotate__UUeHC"};